export default __webpack_public_path__ + "static/Acceptable_Use_Policy-58f4a07ef2a553ea429bcac9d2d40bb3.pdf";